import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import ListItem from "@mui/material/ListItem";
import { Comment, EmailOutlined, Payment, Person, Phone } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDisplayChartUp } from "@fortawesome/pro-regular-svg-icons";

export const SettingLabel = (props) => {
  const { active, menu, ...other } = props;

  const icon = {
    Email: <EmailOutlined />,
    PhoneNumber: <Phone />,
    ClientComment: <Comment />,
    Position: <FontAwesomeIcon icon={faDisplayChartUp} size="xl" />,
    TTransaction: <Payment />,
    Client: <Person />,
  };

  return (
    <ListItem
      disableGutters
      disablePadding
      sx={{
        "& + &": {
          mt: 1,
        },
      }}
      {...other}
    >
      <ButtonBase
        sx={{
          borderRadius: 1,
          color: "text.secondary",
          flexGrow: 1,
          fontSize: (theme) => theme.typography.button.fontSize,
          fontWeight: (theme) => theme.typography.button.fontWeight,
          justifyContent: "flex-start",
          lineHeight: (theme) => theme.typography.button.lineHeight,
          py: 1,
          px: 2,
          textAlign: "left",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          ...(active && {
            backgroundColor: "action.selected",
            color: "text.primary",
          }),
        }}
      >
        {icon[menu?.value]}
        <Box sx={{ flexGrow: 1, ml: 1 }}>{menu?.label ?? ""}</Box>
      </ButtonBase>
    </ListItem>
  );
};

SettingLabel.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};
